import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Dropdown from "react-bootstrap/Dropdown";
import CustomToggle from "./CustomToggle";

interface InvitedUser {
  id: string;
  email: string;
  role: string;
  accepted: boolean;
  createdAt: string;
}

const InvitedList: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const { list, onDelete, onUpdate } = props;

  const intl = useIntl();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const onChangeUserRole = async (userId: string, role: string) => {
    console.log("Change role", userId, role);
    return onUpdate(userId, role);
  };

  return (
    <div>
      <table className="table ">
        <thead>
          <tr>
            <th>
              <FormattedMessage id="invitedList.emailLabel" />
            </th>
            <th>
              <FormattedMessage id="invitedList.roleLabel" />
            </th>
            <th>
              <FormattedMessage id="invitedList.dateLabel" />
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {list.map((user, index) => (
            <tr key={index}>
              <td>{user.email}</td>
              <td>
                {user.accepted ? (
                  <select
                    style={{ maxWidth: "150px" }}
                    className="form-select form-select-sm"
                    value={user.role}
                    onChange={(e) => onChangeUserRole(user.id, e.target.value)} // <-- implement this
                  >
                    <option value="admin">
                      {intl.formatMessage({
                        id: "teams.rol.admin",
                        defaultMessage: "Admin",
                      })}
                    </option>
                    <option value="user">
                      {intl.formatMessage({
                        id: "teams.rol.user",
                        defaultMessage: "User",
                      })}
                    </option>
                  </select>
                ) : (
                  <span className="badge text-bg-warning">Pending</span>
                )}
              </td>
              <td>{formatDate(user.createdAt)}</td>
              <td style={{ textAlign: "right" }}>
                <Dropdown>
                  <Dropdown.Toggle
                    id="dropdown-custom-components"
                    as={CustomToggle}
                  >
                    Custom toggle
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      eventKey="1"
                      onClick={() => onDelete(user.id)}
                    >
                      {user.accepted ? (
                        <FormattedMessage id="common.remove" />
                      ) : (
                        <FormattedMessage id="common.cancel" />
                      )}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

interface ILayoutProps {
  list: InvitedUser[];
  onDelete: (_id: string) => void;
  onUpdate: (_id: string, role: string) => void;
}

export default InvitedList;
